const GenderMap = (gender: string, locale?: any) => {
  if (gender === 'Male' && locale === 'ar') {
    return 'ولد'
  }
  if (gender === 'male' && locale === 'ar') {
    return 'ولد'
  }

  if (gender === 'Female' && locale === 'ar') {
    return 'بنت'
  }
  if (gender === 'female' && locale === 'ar') {
    return 'بنت'
  }
  if (gender === 'Male' && locale === 'en') {
    return 'Boy'
  }
  if (gender === 'male' && locale === 'en') {
    return 'Boy'
  }

  if (gender === 'Female' && locale === 'en') {
    return 'Girl'
  }
  if (gender === 'female' && locale === 'en') {
    return 'Girl'
  }
}

export default GenderMap
